import { ShieldCheck } from "lucide-react";
import {
  Create,
  Datagrid,
  Edit,
  FunctionField,
  List,
  ReferenceField,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import {
  CardListActions,
  EditorToolbar,
  OrganizationInput,
} from "../../components";

const EditTitle = () => <span>{`User Organization Permissions`}</span>;

function renderEditForm() {
  return (
    <SimpleForm toolbar={<EditorToolbar />}>
      <OrganizationInput source="organization_id" />
      <TextInput source="user_id" />
      <SelectInput
        source="permission"
        choices={[
          { id: "upload-lecture", name: "Upload Lectures" },
          { id: "view-stats", name: "View Stats" },
        ]}
      />
    </SimpleForm>
  );
}

function CreateView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Create
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Organization permission created successfully!", {
            type: "success",
          });
          refresh(); // Ensures UI updates with the new data
          redirect("list", "user-organization-permissions");
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Create>
  );
}

function EditView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  console.log({ edit: props });
  return (
    <Edit
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Organization permission updated successfully!", {
            type: "success",
          });
          refresh(); // Ensures UI updates with the new data
          redirect(false);
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
      title={<EditTitle />}
    >
      {renderEditForm()}
    </Edit>
  );
}

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions />}
      //   exporter={true}
      filters={[
        <TextInput source="user_id" alwaysOn placeholder="User ID" />,
        <OrganizationInput
          label="Organization"
          source="organization_id"
          reference="organizations"
          alwaysOn
        />,
      ]}
      perPage={25}
      sort={{ field: "user_id", order: "ASC" }}
      title="User Organization Permissions"
    >
      <Datagrid rowClick="edit">
        <ReferenceField source="organization_id" reference="organizations">
          <FunctionField label="Name" render={(record) => `${record.name}`} />
        </ReferenceField>
        <TextField source="user_id" label="User ID" />
        <ReferenceField source="user_id" reference="users" label="User Email">
          <TextField source="email" />
        </ReferenceField>
        <TextField source="permission" />
        {/* <TextField source="title" label="Title" />
        <TextField source="title_short" label="Short title" />
        <NumberField source="id" label="Id" /> */}
      </Datagrid>
    </List>
  );
}

export const UserOrganizationPermissions = {
  category: "stats",
  name: "user-organization-permissions",
  create: CreateView,
  edit: EditView,
  icon: ShieldCheck,
  list: ListView,
  options: { label: "User-Organization Permissions" },
};
